module.exports = {"TXTCLI_Play":{"id":"TXTCLI_Play","defaultMessage":"Παίξε","flags":["TRACK"],"track":"Play"}}